import React, { Component } from 'react';

const prefixes = {
	services: 'providerServices.service.description:',
	brands: 'providerLocationBrandMatrix.brand.brandName:',
	categories: 'providerLocationBrandMatrix.category.name:',
};

// TODO: Important: Set initial filter UI based on the global store values
class Filters extends Component {
	constructor(props) {
		super(props);
		this.state = {
			services: Array(props.services.length),
			brands: Array(props.brands.length),
			categories: Array(props.categories.length),
		};
	}

	updateFilters(index, value, type) {
		// Update the new filter array immutably
		let newFilters =
			type === 'services'
				? [...this.state.services]
				: type === 'brands'
				? [...this.state.brands]
				: [...this.state.categories];

		// Toggle the filter value
		// If the new upcoming filter value is invalid, put empty array. Otherwise put new filter value.
		newFilters[index] = !newFilters[index] ? value : '';

		// Replace with new values and update the global store
		// after the state is changed
		if (type === 'services') {
			this.setState(
				{
					services: newFilters,
				},
				() => {
					this.props.updateFilters(this.state);
				}
			);
		} else if (type === 'brands') {
			this.setState(
				{
					brands: newFilters,
				},
				() => {
					this.props.updateFilters(this.state);
				}
			);
		} else {
			this.setState(
				{
					categories: newFilters,
				},
				() => {
					this.props.updateFilters(this.state);
				}
			);
		}
	}

	// Apply filters from the filters reducer
	synchronize() {
		const { brands, categories, services } = this.props.filters;

		let newServices = [...this.state.services];
		let newBrands = [...this.state.brands];
		let newCategories = [...this.state.categories];

		services.forEach((element, index) => {
			newServices[index] = element ? element : '';
		});
		brands.forEach((element, index) => {
			newBrands[index] = element ? element : '';
		});
		categories.forEach((element, index) => {
			newCategories[index] = element ? element : '';
		});

		this.setState({
			services: newServices,
			brands: newBrands,
			categories: newCategories,
		});
	}

	componentDidMount() {
		this.synchronize();
	}

	render() {
		const { categories, brands, services } = this.props;
		return (
			<div className="filters-container">
				<ul>
					<li>
						<button className="btn">
							<i className="fas fa-bars"></i> Services
						</button>

						<div className="hidden-filters services">
							<ul>
								{services.map((item, index) => {
									return (
										<li key={item.id}>
											<button
												className={`btn ${this.state.services[index] ? 'active' : ''}`}
												onClick={() =>
													this.updateFilters(
														index,
														`${prefixes.services}${item.description}`,
														'services'
													)
												}>
												{!this.state.services[index] && <i className="far fa-square"></i>}
												{this.state.services[index] && <i className="far fa-check-square"></i>}
												{item.description}
											</button>
										</li>
									);
								})}
							</ul>
						</div>
					</li>

					<li>
						<button className="btn">
							<i className="fas fa-bars"></i> Brands
						</button>

						<div className="hidden-filters brands">
							<ul>
								{brands.map((item, index) => (
									<li key={item.id}>
										<button
											className={`btn ${this.state.brands[index] ? 'active' : ''}`}
											onClick={() =>
												this.updateFilters(
													index,
													`${prefixes.brands}${item.brandName}`,
													'brands'
												)
											}>
											{!this.state.brands[index] && <i className="far fa-square"></i>}
											{this.state.brands[index] && <i className="far fa-check-square"></i>}
											{item.brandName}
										</button>
									</li>
								))}
							</ul>
						</div>
					</li>

					<li>
						<button className="btn">
							<i className="fas fa-bars"></i> Categories
						</button>

						<div className="hidden-filters">
							<ul>
								{categories.map((item, index) => (
									<li key={item.id}>
										<button
											className={`btn ${this.state.categories[index] ? 'active' : ''}`}
											onClick={() =>
												this.updateFilters(
													index,
													`${prefixes.categories}${item.name}`,
													'categories'
												)
											}>
											{!this.state.categories[index] && <i className="far fa-square"></i>}
											{this.state.categories[index] && <i className="far fa-check-square"></i>}
											{item.name}
										</button>
									</li>
								))}
							</ul>
						</div>
					</li>
				</ul>
			</div>
		);
	}
}

export default Filters;
